import React from 'react'
import { Switch, Route } from 'react-router-dom'
import * as routes from 'constants/routes'

import CustomersIndex from 'containers/Customers/CustomersIndex'
import CustomersCreate from 'containers/Customers/CustomersCreate'
import CustomersEdit from 'containers/Customers/CustomersEdit'
import CustomersShow from 'containers/Customers/CustomersShow'

function CustomersRoutes(props) {
  return (
    <Switch>
      <Route exact path={`${routes.CUSTOMERS}`} component={CustomersIndex}/>
      <Route path={`${routes.CUSTOMERS}/create`} component={CustomersCreate}/>
      <Route path={`${routes.CUSTOMERS}/:id/show`} component={CustomersShow}/>
      <Route path={`${routes.CUSTOMERS}/:id/edit`} component={CustomersEdit}/>
    </Switch>
  )
}

export default CustomersRoutes